import type { CommChannel } from './types';

export interface ChannelMeta {
  label: string;
  bg: string;
  text: string;
  darkBg: string;
  darkText: string;
  iconPath: string;
}

const CHANNEL_META: Record<CommChannel, ChannelMeta> = {
  WHATSAPP: {
    label: 'WhatsApp',
    bg: 'bg-emerald-100', text: 'text-emerald-700',
    darkBg: 'dark:bg-emerald-900/30', darkText: 'dark:text-emerald-300',
    iconPath: 'M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347z',
  },
  EMAIL: {
    label: 'Email',
    bg: 'bg-blue-100', text: 'text-blue-700',
    darkBg: 'dark:bg-blue-900/30', darkText: 'dark:text-blue-300',
    iconPath: 'M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z',
  },
  SMS: {
    label: 'SMS',
    bg: 'bg-neutral-100', text: 'text-neutral-700',
    darkBg: 'dark:bg-neutral-700/60', darkText: 'dark:text-neutral-200',
    iconPath: 'M8 12h.01M12 12h.01M16 12h.01M21 12c0 4.418-4.03 8-9 8a9.863 9.863 0 01-4.255-.949L3 20l1.395-3.72C3.512 15.042 3 13.574 3 12c0-4.418 4.03-8 9-8s9 3.582 9 8z',
  },
  INSTAGRAM: {
    label: 'Instagram',
    bg: 'bg-pink-100', text: 'text-pink-700',
    darkBg: 'dark:bg-pink-900/30', darkText: 'dark:text-pink-300',
    iconPath: 'M16 11.37A4 4 0 1112.63 8 4 4 0 0116 11.37zm1.5-4.87h.01M6.5 3h11A3.5 3.5 0 0121 6.5v11a3.5 3.5 0 01-3.5 3.5h-11A3.5 3.5 0 013 17.5v-11A3.5 3.5 0 016.5 3z',
  },
  FACEBOOK: {
    label: 'Facebook',
    bg: 'bg-indigo-100', text: 'text-indigo-700',
    darkBg: 'dark:bg-indigo-900/30', darkText: 'dark:text-indigo-300',
    iconPath: 'M18 2h-3a5 5 0 00-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 011-1h3z',
  },
  // A shared public link (e.g. a quotation's "Copy public link") — nothing is delivered.
  LINK: {
    label: 'Link',
    bg: 'bg-violet-100', text: 'text-violet-700',
    darkBg: 'dark:bg-violet-900/30', darkText: 'dark:text-violet-300',
    iconPath: 'M13.828 10.172a4 4 0 00-5.656 0l-4 4a4 4 0 105.656 5.656l1.102-1.101m-.758-4.899a4 4 0 005.656 0l4-4a4 4 0 00-5.656-5.656l-1.1 1.1',
  },
};

export function channelMeta(channel: CommChannel | string): ChannelMeta {
  return CHANNEL_META[channel as CommChannel] ?? CHANNEL_META.EMAIL;
}

export const ALL_CHANNELS: CommChannel[] = ['WHATSAPP', 'EMAIL', 'SMS', 'INSTAGRAM', 'FACEBOOK'];
export const MESSAGING_CHANNELS: CommChannel[] = ['WHATSAPP', 'EMAIL', 'SMS'];
export const DEAL_CHANNELS: CommChannel[] = ['WHATSAPP', 'INSTAGRAM', 'FACEBOOK'];
